// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedia2DPlay_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 16.3013H5.868V14.9933H1.908V14.9213L3.264 13.6133C3.744 13.1653 4.156 12.7493 4.5 12.3653C4.852 11.9733 5.12 11.5853 5.304 11.2013C5.488 10.8093 5.58 10.3813 5.58 9.91728C5.58 9.46928 5.472 9.07328 5.256 8.72928C5.04 8.37728 4.732 8.10528 4.332 7.91328C3.94 7.71328 3.468 7.61328 2.916 7.61328C2.228 7.61328 1.66 7.72928 1.212 7.96128C0.772 8.18528 0.376 8.44928 0.024 8.75328L0.852 9.74928C1.188 9.47728 1.512 9.26928 1.824 9.12528C2.136 8.97328 2.472 8.89728 2.832 8.89728C3.208 8.89728 3.504 8.99728 3.72 9.19728C3.944 9.38928 4.056 9.68128 4.056 10.0733C4.056 10.3933 3.988 10.6933 3.852 10.9733C3.724 11.2453 3.52 11.5373 3.24 11.8493C2.968 12.1613 2.616 12.5373 2.184 12.9773L0 15.1853V16.3013Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2632 15.2093C14.0712 14.4733 14.4752 13.3813 14.4752 11.9333C14.4752 11.0213 14.2952 10.2533 13.9352 9.62928C13.5832 9.00528 13.0832 8.53328 12.4352 8.21328C11.7872 7.89328 11.0192 7.73328 10.1312 7.73328H7.46719V16.3013H9.87919C11.3272 16.3013 12.4552 15.9373 13.2632 15.2093ZM12.1592 9.72528C12.6312 10.2053 12.8672 10.9573 12.8672 11.9813C12.8672 14.0053 11.8872 15.0173 9.92719 15.0173H9.00319V9.00528H10.1312C11.0112 9.00528 11.6872 9.24528 12.1592 9.72528Z" class="svg-bg"/>
  <path d="M24 12.0005L18 8.00049V16.0005L24 12.0005Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedia2DPlay is a generated icon component.
 */
let IconMedia2DPlay = IconMedia2DPlay_1 = class IconMedia2DPlay extends IconBaseElement {
    render() {
        return html `${IconMedia2DPlay_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedia2DPlay.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedia2DPlay = IconMedia2DPlay_1 = __decorate([
    customElement('zui-icon-media-2-d-play')
], IconMedia2DPlay);
export { IconMedia2DPlay };
